import api from '@/utils/api';

export default {
    data: () => ({rosterExclusionVisible: false, rosterExclusionLine: null, rosterExclusionSheetId: null,
        rosterExclusionPending: false, rosterExclusionError: '', rosterExclusionDone: false, rosterExclusionIdentity: '', bulkResult: null}),
    watch: {
        employeeSearchContext() { this.bulkResult = null; this.rosterExclusionVisible = false; },
        manualRemovalIdentity() { this.rosterExclusionVisible = false; }
    },
    methods: {
        canExcludeRosterLine(line) { return Boolean(this.canEdit && line && line.can_exclude_month); },
        openRosterExclusion(line) {
            if (!this.canExcludeRosterLine(line) || this.rosterExclusionPending) return;
            this.rosterExclusionLine = {...line};
            this.rosterExclusionSheetId = this.currentTimesheetId();
            this.rosterExclusionError = '';
            this.rosterExclusionDone = false;
            this.rosterExclusionIdentity = this.manualRemovalIdentity;
            this.rosterExclusionVisible = true;
        },
        async submitRosterExclusion(reason) {
            if (this.rosterExclusionPending) return;
            this.rosterExclusionError = '';
            if (!this.canEdit || this.rosterExclusionSheetId !== this.currentTimesheetId() || this.rosterExclusionIdentity !== this.manualRemovalIdentity) {
                this.rosterExclusionError = 'Открыт другой табель или изменились права. Откройте действие заново.';
                return;
            }
            this.rosterExclusionPending = true;
            const identity = this.rosterExclusionIdentity;
            const sheetId = this.rosterExclusionSheetId;
            const line = this.rosterExclusionLine;
            const isCurrent = () => this.rosterExclusionVisible && identity === this.manualRemovalIdentity && this.rosterExclusionLine === line;
            let release = () => {};
            try {
                if (!this.rosterExclusionDone) {
                    if (this._editQueue) release = await this._editQueue.pause();
                    if (!isCurrent() || !this.canEdit) return;
                    await api.post(`/api/timesheets/${sheetId}/lines/${line.id}/exclude`,
                        {...reason, expected_token: line.exclusion_token}, {ignoreModal: true});
                    if (!isCurrent()) return;
                    this.rosterExclusionDone = true;
                    this.discardRemovedLineDrafts(line.id);
                    release();
                }
                await this.loadTimesheet(sheetId, {syncRoute: false, ignoreModal: true, isCurrent});
                if (!isCurrent()) return;
                this.rosterExclusionPending = false;
                this.rosterExclusionVisible = false;
                this.successMessage = `${line.employee_name_snapshot} убран из табеля. Вернуть можно через «Добавить сотрудника».`;
            } catch (error) {
                if (!isCurrent()) return;
                const status = error && error.response && error.response.status;
                if (this.rosterExclusionDone && (status === 401 || status === 403)) {
                    this.rosterExclusionVisible = false;
                    this.clearCurrentTimesheet();
                    this.errorMessage = 'Сотрудник убран из табеля. Просмотр табеля сейчас недоступен.';
                } else this.rosterExclusionError = this.rosterExclusionDone
                    ? 'Сотрудник убран. Не удалось обновить табель — повторите обновление.'
                    : this.responseMessage(error, 'Не удалось убрать сотрудника. Причина сохранена.');
            } finally { release(); this.rosterExclusionPending = false; }
        }
    }
};
